// For single cart drawer
const drawer = document.getElementById('garden-drawer');
const drawerTitle = drawer.querySelector('.garden-drawer__title');
const drawerCustomer = drawer.querySelector('.garden-drawer__customer');
const drawerProducts = drawer.querySelector('.garden-drawer__products');

// Open drawer and populate with garden data
document.querySelectorAll('.shop-this-garden').forEach(button => {
  button.addEventListener('click', (e) => {
    const handle = e.target.closest('[data-garden-handle]').dataset.gardenHandle;

    /* console.log('Clicked handle:', handle);
    console.log('window.gardenData:', window.gardenData);
    console.log('Available gardens:', Object.keys(window.gardenData)); */

    const garden = window.gardenData[handle];

    if (!garden) {
      console.error(`No garden found for handle: "${handle}". Available:`, Object.keys(window.gardenData));
      return;
    }

    // Set title
    drawerTitle.textContent = garden.title;
    drawerCustomer.textContent = garden.zone;

    /* console.log(drawerCustomer);
    console.log(garden.customer); */
    console.log("--------------");
    console.log(garden.products);

    // Build product list
    drawerProducts.innerHTML = garden.products.map(p => `
      <div class="garden-product${p.soldOut ? ' is-sold-out' : ''}">
        <div class="p-img">
          <img src="${p.image}" alt="${p.title}">
        </div>
        <div class="p-product">
          <p class="pt">${p.title}</p>

          <div class="pp-qty">
            <p class="pp">${p.price}</p>
            ${p.soldOut
              ? `<div class="sold-out">Returning Soon</div>`
              : `<div class="qty" data-variant-id="${p.variantId}">
                   <button class="dec" aria-label="decrease" disabled>−</button>
                   <span class="q">0</span>
                   <button class="inc" aria-label="increase">+</button>
                 </div>`
            }
          </div>
        </div>
      </div>
    `).join('');

    // Wire up qty buttons
    drawerProducts.querySelectorAll('.qty').forEach(qty => {
      const dec = qty.querySelector('.dec');
      const inc = qty.querySelector('.inc');
      const q = qty.querySelector('.q');

      inc.addEventListener('click', () => {
        const val = parseInt(q.textContent) + 1;
        q.textContent = val;
        dec.disabled = val === 0;
      });

      dec.addEventListener('click', () => {
        const val = Math.max(0, parseInt(q.textContent) - 1);
        q.textContent = val;
        dec.disabled = val === 0;
      });
    });


    // Set full image or video
    const fullUrl = e.target.closest('[data-full]').dataset.full;
    const mediaType = e.target.closest('[data-media-type]').dataset.mediaType;

    document.getElementById('garden-image-full').innerHTML = mediaType === 'video'
      ? `<video src="${fullUrl}" autoplay muted loop playsinline controls></video>`
      : `<img src="${fullUrl}" alt="${garden.title}">`;



    // The main element is below some other's so we need to shift it up
    document.body.style.overflow = 'hidden';
    document.getElementById('MainContent').style.position = 'relative';
    document.getElementById('MainContent').style.zIndex = '9999';

    // Open garden drawer
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
  });
});


function closeGardenDrawer() {
  // When closing the drawer (all close triggers)
  drawer.setAttribute('aria-hidden', 'true');
  drawer.classList.remove('is-open');
  document.body.style.overflow = '';

  // reset main
  document.getElementById('MainContent').style.position = '';
  document.getElementById('MainContent').style.zIndex = '';

  // remove content to stop any videos
  document.getElementById('garden-image-full').innerHTML = '';
}
// Close drawer
drawer.querySelector('.garden-drawer__close').addEventListener('click', () => {
  closeGardenDrawer();
});
drawer.querySelector('.garden-drawer__overlay').addEventListener('click', () => {
  closeGardenDrawer();
});

// click the expanded image to close
document.getElementById('garden-image-full').addEventListener('click', () => {
  closeGardenDrawer();
});

// click explore garden to run shop this garden
/* Note: changed from .explore-garden button to whole div .explore */
document.querySelectorAll('.explore').forEach(button => {
  button.addEventListener('click', (e) => {
    const card = e.target.closest('article.garden');
    const shopBtn = card.querySelector('.shop-this-garden');
    if (shopBtn) shopBtn.click();
  });
});

async function addToCartAndOpenDrawer(items) {
  //const cartDrawer = document.querySelector('cart-drawer');

  console.log("#########");
  console.log(items);

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  });

  if (!response.ok) {
    const err = await response.json();
    console.error('Cart add failed:', err);
    // err.description gives Shopify's reason, e.g. "All 2 Queen Lime Blush available are already in your cart"
    alert(err.description || 'Some items could not be added to your cart.');
    return;
  }


  const parsedState = await response.json();

  // Update #CartDrawer inner HTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(parsedState.sections['cart-drawer'], 'text/html');
  const newInner = doc.querySelector('#CartDrawer');
  const existingInner = document.getElementById('CartDrawer');

  if (existingInner && newInner) {
    existingInner.innerHTML = newInner.innerHTML;
  }

  // Update cart icon bubble
  const bubbleDoc = parser.parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');
  const newBubble = bubbleDoc.getElementById('cart-icon-bubble');
  const existingBubble = document.getElementById('cart-icon-bubble');
  if (existingBubble && newBubble) {
    existingBubble.innerHTML = newBubble.innerHTML;
  }

  // open the mini cart
  document.getElementById('cart-icon-bubble')?.click();

  // close the community gardens product drawer
  closeGardenDrawer();

}

// Add selected
drawer.querySelector('.add-selected-to-cart').addEventListener('click', async () => {
  const qtys = drawer.querySelectorAll('.qty[data-variant-id]');
  const items = [];
  qtys.forEach(qty => {
    const quantity = parseInt(qty.querySelector('.q').textContent);
    if (quantity > 0) {
      items.push({ id: qty.dataset.variantId, quantity });
    }
  });
  await addToCartAndOpenDrawer(items);
});

// Add all
drawer.querySelector('.add-all-one-click').addEventListener('click', async () => {
  const qtys = drawer.querySelectorAll('.qty[data-variant-id]');
  const items = Array.from(qtys).map(qty => ({
    id: qty.dataset.variantId,
    quantity: 1
  }));
  await addToCartAndOpenDrawer(items);
});


// Zone, province, and text search filtering
const zoneFilter = document.getElementById('filter-zone');
const provinceFilter = document.getElementById('filter-province');
const searchInput = document.getElementById('filter-search');
const clearButton = document.getElementById('clear-filters');
const gardenCount = document.getElementById('garden-count');

function updateCount(visible) {
  const allGardens = document.querySelectorAll('.garden');
  const total = allGardens.length;
  gardenCount.textContent = visible === total
    ? `Showing all ${total} gardens`
    : `Showing ${visible} of ${total} gardens`;
}

function applyFilters() {
  const allGardens = document.querySelectorAll('.garden');
  const selectedZone = zoneFilter.value;
  const selectedProvince = provinceFilter.value;
  const searchTerm = searchInput.value.trim().toLowerCase();
  const isFiltered = selectedZone || selectedProvince || searchTerm;
  let visibleCount = 0;

  allGardens.forEach(card => {
    const zoneMatch = !selectedZone || card.dataset.zone === selectedZone;
    const provinceMatch = !selectedProvince || card.dataset.province === selectedProvince;
    const searchMatch = !searchTerm || [
      card.dataset.customerName,
      card.dataset.location,
      card.dataset.products,
    ].some(val => val?.toLowerCase().includes(searchTerm));

    const show = zoneMatch && provinceMatch && searchMatch;
    card.style.display = show ? '' : 'none';
    if (show) visibleCount++;
  });

  updateCount(visibleCount);
  clearButton.hidden = !isFiltered;
}

function clearFilters() {
  zoneFilter.value = '';
  provinceFilter.value = '';
  searchInput.value = '';
  applyFilters();
}

zoneFilter.addEventListener('change', applyFilters);
provinceFilter.addEventListener('change', applyFilters);
searchInput.addEventListener('input', applyFilters);
clearButton.addEventListener('click', clearFilters);

updateCount(document.querySelectorAll('.garden').length);


// LIKES -> process with likes
const likedEntries = JSON.parse(localStorage.getItem('likedGardens') || '[]');

// Set initial liked state on page load — only add liked class if in localStorage
document.querySelectorAll('.like').forEach(btn => {
  const rawId = btn.dataset.id;
  const id = rawId.startsWith('gid://') ? rawId : `gid://shopify/Metaobject/${rawId}`;
  if (likedEntries.includes(id)) {
    btn.classList.add('liked');
  }
});

async function likeEntry(btn) {
  const rawId = btn.dataset.id;
  const id = rawId.startsWith('gid://') ? rawId : `gid://shopify/Metaobject/${rawId}`;
  const isLiked = likedEntries.includes(id);

  // Optimistic update — apply immediately
  if (isLiked) {
    btn.classList.remove('liked');
  } else {
    btn.classList.add('liked');
  }

  btn.disabled = true;

  try {
    const res = await fetch('/apps/enter-contest', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type: isLiked ? 'unvote' : 'vote', id })
    });

    const result = await res.json();

    if (result.success) {
      if (isLiked) {
        likedEntries.splice(likedEntries.indexOf(id), 1);
      } else {
        likedEntries.push(id);
      }
      btn.querySelector('.n').textContent = result.votes;
      localStorage.setItem('likedGardens', JSON.stringify(likedEntries));
    } else {
      // Revert if fetch failed
      if (isLiked) {
        btn.classList.add('liked');
      } else {
        btn.classList.remove('liked');
      }
    }
  } catch(err) {
    console.error('Like failed:', err);
    // Revert on error
    if (isLiked) {
      btn.classList.add('liked');
    } else {
      btn.classList.remove('liked');
    }
  } finally {
    btn.disabled = false;
  }
}

/* New - build entries */
// Append entries beyond the Liquid 50-entry cap
(function () {
  const container = document.getElementById('community-garden-entries');
  const likedEntries = JSON.parse(localStorage.getItem('likedGardens') || '[]');

  const renderedIds = new Set(
    [...document.querySelectorAll('article.garden')].map(el => el.dataset.id)
  );

  fetch('/apps/enter-contest?type=recent')
    .then(res => res.json())
    .then(data => {
      const missing = data.entries.filter(e => !renderedIds.has(e.id.split('/').pop()));
      if (!missing.length) return;

      missing.forEach(entry => {
        // Build product_titles string for data-products (used by search filter)

        console.log(entry.id.split('/').pop());

        const entryID = entry.id.split('/').pop();

        const productTitles = entry.gardenProducts
          .map(p => p.title.replace(/,/g, ''))
          .join(',');

        // Name display logic
        const nameParts = (entry.customerName || '').split(' ');
        const displayName = nameParts.length > 1
          ? `${nameParts[0]} ${nameParts[nameParts.length - 1].charAt(0)}.`
          : entry.customerName || '—';

        // Media
        const mediaSection = entry.isVideo && entry.videoUrl
          ? `<video loading="lazy" autoplay muted loop playsinline><source src="${entry.videoUrl}" type="video/mp4"></video>`
          : entry.imageUrl
            ? `<img src="${entry.imageUrl}" alt="${entry.caption ?? ''}" loading="lazy">`
            : '';

        // Products list
        const productItems = entry.gardenProducts.map(p => `
          <li>
            ${p.title}
            ${p.variantAvailable
              ? `<span class="packet-cost">$${(parseFloat(p.price ?? 0) / 100).toFixed(2)}</span>`
              : `<span class="packet-cost sold-out">Returning Soon!</span>`
            }
          </li>
        `).join('');

        // Variant IDs for cart
        const variantIds = entry.gardenProducts
          .filter(p => p.variantId && p.variantAvailable)
          .map(p => p.variantId.split('/').pop())
          .join(',');

        const productCount = entry.gardenProducts.length;
        const isLiked = likedEntries.includes(entryID);
        const zoneLabel = `Zone ${entry.zone ?? '—'} - ${entry.customerLocation ?? '—'}, ${entry.customerProvince ?? '—'}`;

        const article = document.createElement('article');
        article.className = 'garden';
        article.dataset.id = entryID;
        article.dataset.zone = entry.zone ?? '';
        article.dataset.province = entry.customerProvince ?? '';
        article.dataset.location = entry.customerLocation ?? '';
        article.dataset.customerName = entry.customerName ?? '';
        article.dataset.products = productTitles;

        article.innerHTML = `
          <div class="garden-inner">
            <div class="garden-card">
              <span class="zone bubbles zone-${entry.zone ?? ''}">Zone ${entry.zone ?? '—'} - ${entry.customerLocation ?? '—'}, ${entry.customerProvince ?? '—'}</span>

              <button class="like bubbles${isLiked ? ' liked' : ''}"
                data-id="${entryID}"
                data-count="${entry.votes ?? 0}"
                onclick="likeEntry(this)">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path class="heart-stroke" d="M12 20s-7-4.35-7-10a4 4 0 0 1 7-2.65A4 4 0 0 1 19 10c0 5.65-7 10-7 10Z"></path><path class="heart-fill" d="M12 20s-7-4.35-7-10a4 4 0 0 1 7-2.65A4 4 0 0 1 19 10c0 5.65-7 10-7 10Z"></path></svg>
                <span class="n">${entry.votes ?? 0}</span>
              </button>

              <div class="customer-name bubbles">${displayName}</div>

              <section class="garden-image${entry.isVideo ? ' video' : ''}">
                ${mediaSection}
              </section>

              <div class="explore">
                <button class="explore-garden btn btn-ghost">Explore Garden</button>
              </div>
            </div>

            <section class="garden-varities">
              <details>
                <summary>Shop ${productCount} ${productCount === 1 ? 'Seed' : 'Seeds'} → ${(entry.caption ?? '').substring(0, 20)}${(entry.caption ?? '').length > 20 ? '...' : ''}</summary>
                <div class="packet-details">
                  <ul class="garden-products">
                    ${productItems}
                  </ul>
                  ${variantIds ? `
                  <button class="shop-this-garden btn btn-secondary"
                    data-garden-handle="${entry.handle}"
                    data-garden-title="${entry.caption ?? ''}"
                    data-garden-customer="${entry.customerName ?? ''}"
                    data-garden-zone="${zoneLabel}"
                    data-variant-ids="${variantIds}"
                    data-full="${entry.fullUrl ?? ''}"
                    data-media-type="${entry.isVideo ? 'video' : 'image'}">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 8h14l-1.2 11.1A2 2 0 0 1 15.8 21H8.2a2 2 0 0 1-2-1.9L5 8Zm3 0V6a4 4 0 1 1 8 0v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>
                    Shop this garden
                  </button>` : ''}
                </div>
              </details>
            </section>
          </div>
        `;

        // Add to window.gardenData for drawer
        window.gardenData[entry.handle] = {
          title: entry.caption,
          customer: entry.customerName,
          zone: zoneLabel,
          products: entry.gardenProducts.map(p => ({
            title: p.title,
            price: `$${(parseFloat(p.price ?? 0) / 100).toFixed(2)}`,
            image: p.image,
            variantId: p.variantId?.split('/').pop(),
            soldOut: !p.variantAvailable
          }))
        };

        container.appendChild(article);

        // Wire up explore-garden button for this entry
        /* Note: changed from .explore-garden button to whole div .explore */
        article.querySelector('.explore')?.addEventListener('click', (e) => {
          const shopBtn = article.querySelector('.shop-this-garden');
          if (shopBtn) shopBtn.click();
        });

        // Wire up shop-this-garden button for this entry
        article.querySelector('.shop-this-garden')?.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-garden-handle]');
          const handle = btn.dataset.gardenHandle;
          const garden = window.gardenData[handle];
          if (!garden) return;

          drawerTitle.textContent = garden.title;
          drawerCustomer.textContent = garden.zone;

          drawerProducts.innerHTML = garden.products.map(p => `
            <div class="garden-product">
              <div class="p-img"><img src="${p.image}" alt="${p.title}"></div>
              <div class="p-product">
                <p class="pt">${p.title}</p>
                <div class="pp-qty">
                  <p class="pp">${p.price}</p>
                  ${p.soldOut
                    ? `<div class="sold-out">Returning Soon</div>`
                    : `<div class="qty" data-variant-id="${p.variantId}">
                        <button class="dec" aria-label="decrease" disabled>−</button>
                          <span class="q">0</span>
                        <button class="inc" aria-label="increase">+</button>
                      </div>`
                }
                </div>
              </div>
            </div>
          `).join('');

          drawerProducts.querySelectorAll('.qty').forEach(qty => {
            const dec = qty.querySelector('.dec');
            const inc = qty.querySelector('.inc');
            const q = qty.querySelector('.q');
            inc.addEventListener('click', () => {
              const val = parseInt(q.textContent) + 1;
              q.textContent = val;
              dec.disabled = val === 0;
            });
            dec.addEventListener('click', () => {
              const val = Math.max(0, parseInt(q.textContent) - 1);
              q.textContent = val;
              dec.disabled = val === 0;
            });
          });

          const fullUrl = btn.dataset.full;
          const mediaType = btn.dataset.mediaType;
          document.getElementById('garden-image-full').innerHTML = mediaType === 'video'
            ? `<video src="${fullUrl}" autoplay muted loop playsinline controls></video>`
            : `<img src="${fullUrl}" alt="${garden.title}">`;

          document.body.style.overflow = 'hidden';
          document.getElementById('MainContent').style.position = 'relative';
          document.getElementById('MainContent').style.zIndex = '9999';
          drawer.setAttribute('aria-hidden', 'false');
          drawer.classList.add('is-open');
        });
      });

      // Re-run filters to include newly appended entries
      applyFilters();
    })
    .catch(err => console.error('Failed to load additional garden entries:', err));
})();
